import axios from "axios";
import {
  UPDATE_DATA,
  GET_ALL_ADMISSION_FORM_LIST,
  GET_USERDETAILS_BY_USERID
} from "./types";
const keys = require("../config/keys");

export const getAllAdmissionFormList = () => async dispatch => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/AdmissionForm/GetAllAdmissionFormList"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ALL_ADMISSION_FORM_LIST,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getAllAdmissionFormListByStudentId = StudentId => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetAllAdmissionFormListByStudentId?StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ALL_ADMISSION_FORM_LIST,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const admissionPersonalInfoInsert = data => async dispatch => {
  await axios({
    method: "post",
    url: keys.ServicePath + "/api/AdmissionForm/InsertAdmissionPersonalInfo",
    data: data
  })
    .then(res => {
      if (res.data.success) {
        try {
          const msg = {
            event: "success",
            action: "add",
            page: "PersonalInfo",
            data: res.data.data,
            success: true,
            redirectTab: true,
            ...res.data
          };

          dispatch({ type: UPDATE_DATA, payload: msg });
          dispatch({ type: GET_USERDETAILS_BY_USERID, payload: res.data.data });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const admissionAcademicProfileInsert = data => async dispatch => {
  await axios({
    method: "post",
    url: keys.ServicePath + "/api/AdmissionForm/InsertAdmissionAcademicProfile",
    data: data
  })
    .then(res => {
      if (res.data.success) {
        try {
          const msg = {
            event: "success",
            action: "add",
            page: "Academic Profile",
            data: res.data.data,
            success: true,
            redirectTab: true,
            ...res.data
          };
          dispatch({ type: UPDATE_DATA, payload: msg });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/admissionAcademicProfileInsert.js